export const dateFormat = 'MM/dd/yyyy';

export const dateFormatWithDashes = 'MM-dd-yyyy';

export const timeFormat = 'h:mm a';

export const dateTimeFormat = 'MM/dd/yyyy h:mm a';

export const extendedDateFormat = 'LLL dd, yy';

export const extendedDateTimeFormat = "LLL dd, yy 'at' h:mm a";

export const eventHeldOnMaxDate = new Date(2026, 6, 31, 23, 59, 59, 999);
